<template>
  <div class="topContacts">
    <pendant :titleName="'Visitor information'"></pendant>
    <ul>
      <li v-for="(item, index) in usefulPersonInfos" :key="item.id" @click="clickCommonlyUsed(item, index)" :class="{ 'currentSelect': item.active }" class="item">
        <span>{{ item.name }}</span>
        <img src="~@/assets/image/common/common_select.png" alt="">
        <i class="tag" :class="{ 'dim': item.tag === 'un_set' }">{{ item.tagName }}</i>
      </li>
      <li @click="incrementUsefulPerson" v-if="!zg" class="increment">
        <div class="increment-text">
          <div>Add/Refill</div>
          <!-- <div>更换</div> -->
        </div>
        <img src="~@/assets/image/common/common_goTo2.png" alt="">
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: "topContacts",
  props: {
    usefulPersonInfos: {
      type: Array,
      default: () => [],
    },
    controllerNumber: {
      type: Array,
      default: () => [],
    },
    zg: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    clickCommonlyUsed(item, index){
      const options = {
        active: !item.active,
        index,
        tag: item.tag
      };
      this.$emit('changeTopContacts', options)
      this.$forceUpdate();
    },
    incrementUsefulPerson(){
      window.sessionStorage.setItem('oftenContacts', JSON.stringify(this.usefulPersonInfos));
      window.sessionStorage.setItem('controllerNumber', JSON.stringify(this.controllerNumber));
      this.$router.push(`/oftencontactlist?callbackpath=${this.$route.name.toLowerCase()}`);
    }
  }
};
</script>

<style scoped lang='less'>
.topContacts{
  padding: .266667rem;
  background: #FFFFFF;
  margin-top: .266667rem;
  & > ul{
    margin-left: -.4rem;
    display: flex;
    flex-wrap: wrap;
    li{
      line-height: .986667rem;
      padding: 0 .453333rem;
      background: #FFFFFF;
      box-shadow: 0 .053333rem .106667rem 0 rgba(0,0,0,0.06);
      border-radius: .16rem;
      border: 1px solid rgba(151, 151, 151, 0.07);
      font-size: .373333rem;
      color: #333333;
      margin: .213333rem 0 0 0.4rem;
    };
    .item{
      position: relative;
      border: 1px solid #BABED2;
      img{
        display: none;
      }
      .tag{
        position: absolute;
        left: 0;
        top: 0;
        padding: 0 .08rem;
        font-size: .24rem;
        color: #3B6D9C;
        line-height: .333333rem;
        background: rgba(59, 109, 156, 0.07);
        text-align: center;
        padding: 0 .08rem;
        border-radius: .16rem 0 .16rem 0;
      }
      .dim{
        color: #666666 !important;
        background: rgba(153, 153, 153, .3) !important;
      }
    }
    .currentSelect{
      position: relative;
      border: 1px solid #3B6D9C;
      background: rgba(59, 109, 156, 0.07);
      color: #3B6D9C;
      img{
        display: block;
        position: absolute;
        height: .346667rem;
        right: 0;
        bottom: 0;
      }
      .tag{
        color: #FFFFFF;
        background: #3B6D9C;
      }
    }
    .increment{
      display: inline-flex;
      height: .986667rem;
      align-items: center;
      border: 1px solid #BABED2;
      line-height: .44rem;
      .increment-text{
        white-space: nowrap;
      }
      img{
        height: .32rem;
        margin-left: .066667rem;
        vertical-align: -.026667rem;
        margin-left: .4rem;
      }
    }
  }
}
</style>
